import React from 'react';

export const CwIconAll = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" strokeLinecap="round" />
  </svg>
);

export const CwIconPending = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" strokeLinejoin="round" />
  </svg>
);

export const CwIconUnread = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M4 4h16v12H5.2L4 17.2V4z" strokeLinejoin="round" />
    <circle cx="18" cy="6" r="3" fill="currentColor" stroke="none" />
  </svg>
);

export const CwIconResolved = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CwIconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" strokeLinecap="round" />
  </svg>
);

export const CwIconChevronFirst = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M18 17V7M13 17l-5-5 5-5M6 17V7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CwIconChevronPrev = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CwIconChevronNext = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CwIconChevronLast = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M6 17V7M11 17l5-5-5-5M18 17V7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CwIconScrollDown = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true">
    <path d="M12 5v14M6 13l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CwIconProfile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c1.5-4 6.5-4 8-4s6.5 0 8 4" strokeLinecap="round" />
  </svg>
);

export function getConversationInitials(name) {
  const parts = String(name || '?').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
  return (parts[0]?.[0] || '?').toUpperCase();
}

export function formatRefreshAgo(lastRefreshAt, nowMs = Date.now()) {
  if (!lastRefreshAt) return null;
  const diff = Math.max(0, nowMs - lastRefreshAt);
  const sec = Math.floor(diff / 1000);
  if (sec < 5) return 'ahora';
  if (sec < 60) return `hace ${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `hace ${min} min`;
  return new Date(lastRefreshAt).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
}

export function ConversationListSkeleton({ rows = 7 }) {
  return (
    <div className="crm-cw-list-skeleton" aria-hidden="true">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="crm-cw-skeleton-row">
          <span className="crm-cw-skeleton-avatar" />
          <div className="crm-cw-skeleton-lines">
            <span className="crm-cw-skeleton-line crm-cw-skeleton-line--lg" />
            <span className="crm-cw-skeleton-line crm-cw-skeleton-line--sm" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function CwListSearch({ value, onChange, inputRef, placeholder = 'Buscar chats...', onKeyDown }) {
  return (
    <div className="crm-cw-list-search-wrap crm-cw-list-search-wrap--premium">
      <span className="crm-cw-list-search-icon" aria-hidden="true">
        <CwIconSearch />
      </span>
      <input
        ref={inputRef}
        type="text"
        className="crm-cw-list-search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        autoComplete="off"
        spellCheck={false}
      />
      {String(value || '').trim() ? (
        <button
          type="button"
          className="crm-cw-list-search-clear"
          onClick={() => onChange({ target: { value: '' } })}
          aria-label="Limpiar búsqueda"
        >
          ×
        </button>
      ) : null}
    </div>
  );
}

function formatUnreadBadgeCount(count) {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  if (n > 99) return '99+';
  return String(n);
}

export function ConversationListHandlingBadge({ handling }) {
  if (!handling) return null;
  const { kind, label, title } = handling;

  if (kind === 'bot') {
    const botName = String(handling.agentName || 'Anita').trim();
    return (
      <span className="crm-cw-handling-chip crm-cw-handling-chip--bot" title={title || label}>
        <span className="crm-cw-handling-chip__pulse" aria-hidden="true" />
        <span className="crm-cw-handling-chip__label">{botName}</span>
        <span className="crm-cw-handling-chip__sep" aria-hidden="true">
          ·
        </span>
        <span className="crm-cw-handling-chip__sub">En gestión</span>
      </span>
    );
  }

  if (kind === 'human') {
    const short = String(label || '')
      .replace(/^Operador\s*·\s*/i, '')
      .trim();
    return (
      <span className="crm-cw-handling-chip crm-cw-handling-chip--human" title={title || label}>
        <span className="crm-cw-handling-chip__label">Operador</span>
        {short ? (
          <>
            <span className="crm-cw-handling-chip__sep" aria-hidden="true">
              ·
            </span>
            <span className="crm-cw-handling-chip__sub">{short}</span>
          </>
        ) : null}
      </span>
    );
  }

  if (kind === 'finished') {
    return (
      <span className="crm-cw-handling-chip crm-cw-handling-chip--finished" title={title || label}>
        <span className="crm-cw-handling-chip__pulse" aria-hidden="true" />
        <span className="crm-cw-handling-chip__label">Flujo listo</span>
      </span>
    );
  }

  return null;
}

export function ConversationListAvatar({ name, unreadCount = 0 }) {
  const initials = getConversationInitials(name);
  const unreadBadge = formatUnreadBadgeCount(unreadCount);
  const hasUnread = Boolean(unreadBadge);
  return (
    <div
      className={`crm-cw-item-avatar${hasUnread ? ' is-unread' : ''}`}
      aria-hidden="true"
    >
      <span className="crm-cw-item-avatar-initials">{initials}</span>
      {unreadBadge ? (
        <span className="crm-cw-item-avatar-unread">{unreadBadge}</span>
      ) : null}
    </div>
  );
}
